import mount from "../utils/mount";
import Template2001Container from "./Template2001Container";

import "./css/all.css";
import "./css/custom.css";

mount(Template2001Container);
